
import { defineComponent, PropType } from 'vue'
import { BsCheckboxMode } from './BsCheckbox.interfaces'
import { createAutoIncrementIdProp } from '@/utils/props'

export const BsCheckbox = defineComponent({
  name: 'BsCheckbox',
  props: {
    id: createAutoIncrementIdProp('BsCheckbox'),
    modelValue: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    label: {
      type: String as PropType<string>,
      default: ''
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    mode: {
      type: String as PropType<BsCheckboxMode>,
      default: 'regular'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const modeClassMapping: Record<BsCheckboxMode, string> = {
      regular: 'BsCheckbox-label--regular ms-2 my-auto fs-6',
      pill: 'BsCheckbox-label--pill badge rounded-pill fw-normal px-2 px-md-3'
    }

    function handleChange(event: Event) {
      const target = event.target as HTMLInputElement
      emit('update:modelValue', target.checked)
    }

    return {
      handleChange,
      modeClassMapping
    }
  }
})

export default BsCheckbox
